import CampaignsTable from './_table.js'
import template from './call-center-index.pug'

export default Vue.extend({
  template: template(),
  components: {
    CampaignsTable
  },
  data() {
    return {
      campaigns: [],
      meta: {},
      ready: false
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.loadCallCenter()
      }
    }
  },
  methods: {
    loadCallCenter() {
      this.ready = false
      API.callCenters.show(this.$route.params.id).then(callCenter => {
        this.$setPageTitle(this.$t('campaigns.callCenter.title', {name: callCenter.name}))
        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.callCenters.index'), route: {name: 'call-centers-index'}},
          {
            label: this.$t('breadcrumbs.callCenters.show', {name: callCenter.name}),
            route: {name: 'call-centers-show', params: {id: callCenter.id}}
          },
          {
            label: this.$t('breadcrumbs.callCenters.campaigns', {name: callCenter.name}),
            route: {}
          }
        ])

        this.ready = true
      })
    },

    loadCampaigns(queryOptions = {}) {
      queryOptions.filter = queryOptions.filter || {}
      queryOptions.filter.callCenterId = [this.$route.params.id]

      API.campaigns.index(queryOptions).then(({data, meta}) => {
        this.campaigns = data
        this.meta = meta
      })
    }
  }
})
